"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
require("./styles.css");
var WbrString_1 = __importDefault(require("@component/WbrString"));
var MegaNavDesktop = /** @class */ (function (_super) {
    __extends(MegaNavDesktop, _super);
    function MegaNavDesktop(props) {
        var _this = _super.call(this, props) || this;
        _this.MenuHover = function (event) {
            _this.setState(function () { return (__assign(__assign({}, _this.state), { isShown: __assign(__assign({}, _this.state.isShown), { isOpen: true, anchorEl: event.target.id }) })); });
        };
        _this.MenuLeave = function () {
            _this.setState(function () { return (__assign(__assign({}, _this.state), { isShown: __assign(__assign({}, _this.state.isShown), { isOpen: false, anchorEl: null }) })); });
        };
        _this.handleClick = function () {
            console.log('logic');
        };
        _this.state = {
            isShown: {
                isOpen: false,
                anchorEl: null,
            },
        };
        return _this;
    }
    MegaNavDesktop.prototype.render = function () {
        var _this = this;
        var _a = this.props, mainNav = _a.mainNav, navRightInfo = _a.navRightInfo;
        var MenuLinks = function (props) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav_link_box" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mega_nav_links" }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: props.linkOptionTitle }), (0, jsx_runtime_1.jsx)("ul", { children: props.optionLinks &&
                                props.optionLinks.map(function (item, idx) {
                                    return (0, jsx_runtime_1.jsx)("li", { children: item }, idx);
                                }) })] })) })));
        };
        // DesktopMegaNav
        var DesktopNav = function (props) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mega_nav_wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav_left_col" }, { children: props.Left &&
                                    props.Left.map(function (item, idx) {
                                        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "mega_nav_left_box" }, { children: [(0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "div", class: "left_col_title" }, { children: item.title })), (0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "p" }, { children: item.description })), (0, jsx_runtime_1.jsx)("span", __assign({ onClick: _this.MenuLeave }, { children: item.link }))] }), idx));
                                    }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav_right_col" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mega_nav_right_wrapper" }, { children: [props.Right &&
                                            props.Right.map(function (item, idx) {
                                                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "mega_nav_right_box" }, { children: [(0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "div", class: "mega_nav_right_title" }, { children: item.title })), (0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "p" }, { children: item.description })), item.link.props.children.props.field.value.href ? (0, jsx_runtime_1.jsx)("span", __assign({ onClick: _this.MenuLeave }, { children: item.link })) : null] }), idx));
                                            }), props.linkOption ? (0, jsx_runtime_1.jsx)(MenuLinks, __assign({}, props)) : null, props.linkRichText.props.children.props.field ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav_right_box" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "mega_nav_text_link" }, { children: (0, jsx_runtime_1.jsx)(WbrString_1.default, __assign({ tag: "div" }, { children: props.linkRichText.props.children.props.field })) })) }))) : null] })) }))] })) })) })));
        };
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "bottom_bar" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "header_container container" }, { children: [(0, jsx_runtime_1.jsx)("nav", __assign({ className: "main_nav" }, { children: (0, jsx_runtime_1.jsx)("ul", __assign({ onMouseLeave: this.MenuLeave }, { children: mainNav &&
                                mainNav.map(function (item, idx) {
                                    var _a, _b, _c;
                                    return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("a", __assign({ href: item.href, id: item.id, onMouseEnter: _this.MenuHover }, { children: item.label })), ((_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.Left) === null || _b === void 0 ? void 0 : _b.length) > 0 && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(_this.state.isShown.isOpen && ((_c = _this.state.isShown.anchorEl) === null || _c === void 0 ? void 0 : _c.toString()) === item.id.toString() ? 'is-open' : 'is-close'), onMouseLeave: _this.MenuLeave }, { children: (0, jsx_runtime_1.jsx)(DesktopNav, __assign({}, item.options)) })))] }, idx));
                                }) })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "nav_view" }, { children: navRightInfo &&
                            navRightInfo.map(function (item, idx) {
                                return (0, jsx_runtime_1.jsx)("span", { children: item }, idx);
                            }) }))] })) })));
    };
    return MegaNavDesktop;
}(React.Component));
exports.default = MegaNavDesktop;
//# sourceMappingURL=MegaNavdesktop.js.map